import * as React from 'react'

export const LineIcon = React.memo(({
  className,
  ...props
}) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M23.1429 18.8997H0.642883V15.8997H23.1429V18.8997Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.53448 10.8138H6.19611V11.9622H2.14288V5.39969H3.53448V10.8138Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.73322 11.9622H7.34161V5.39969H8.73322V11.9622Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.9896 10.3157H15.0218C14.9769 9.46307 14.9544 8.8598 14.9544 8.50662V5.39969H16.2068V11.9622H14.4373L11.5823 6.99783H11.5428C11.5996 7.8746 11.6277 8.50021 11.6277 8.8743V11.9622H10.3841V5.39969H12.139L14.9896 10.3157Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21.6429 6.5408H19.2552V7.98074H21.4759V9.12186H19.2552V10.8138H21.6429V11.9622H17.8636V5.39969H21.6429V6.5408Z'
        fill='currentColor'
      />
    </svg>
  )
})

LineIcon.displayName = 'LineIcon'
